import { Box, Grid, styled } from "@mui/material";

export const ItemBox = styled(Grid)({
  position: "relative",
  background: "white",
  padding: "2px 10px",
  marginTop: "5px",
  height: "60px",
  boxShadow: "0px 3px 6px #00000029",
  borderRadius: "7px",
  display: "flex",
  alignItems: "center",
});
export const DotedBox = styled(Box)({
  padding: "0 5px",
  height: "24px",
  border: "1px dashed grey",
});
export const RowItem = styled(Box)({
  display: "grid",
  gridTemplateColumns: "60% 40%",
  columnGap: "20px",
  alignItems: "center",
});
export const PicBox = styled(Box)({
  float: "right",
  height: "100px",
  width: "100px",
  border: "1px solid grey",
  background: "grey",
  textAlign: "center",
});
